class IndexedDBService {
    constructor(){
        this.request = {};
        this.db = null;
        this.bookStore = {};

        this.booksData = [];
    }

    initDB(){
        return new Promise((resolve, reject) => {
            this.request = indexedDB.open("mybookshelf", 2);
    
            this.request.onerror = (event) => {
                reject("Why didn't you allow my web app to use IndexedDB?!");
            };
    
            this.request.onsuccess = (event) => {
                this.db = event.target.result;
                resolve();
            };
    
            this.request.onupgradeneeded = (event) => {
                this.db = event.target.result;
    
                this.bookStore = this.db.createObjectStore('books', {keyPath: 'slug'});
    
                this.bookStore.createIndex('slug', 'slug', {unique: true});
                this.bookStore.createIndex('title', 'title', {unique: false});
                this.bookStore.createIndex('content', 'content', {unique: false});
                this.bookStore.createIndex('timestamp', 'timestamp', {unique: false});
            
            }
        })
    }

    getAllData = () => {
        this.booksData = [];
        return new Promise((resolve) => {
            const bookStore = this.db.transaction(["books"], "readwrite").objectStore("books");
                
            const req = bookStore.openCursor();
            req.onsuccess = (e) => {
                let cursor = e.target.result;
                if(cursor) {
                    cursor.continue();
                    this.booksData.push({...cursor.value, storage: 'offline'});
                }else {
                    resolve(this.booksData);
                }
            }
        })
    }

    deleteNotebook = (slug) => {
        const bookCollection = this.db.transaction("books", "readwrite").objectStore("books");
        bookCollection.delete(slug);
    }

    addNotebook = (title, content = [''], timestamp = 0) => {
        return new Promise((resolve, reject) => {
            const data = {
                slug: title.toLowerCase().replace(/ /g, '-'),
                title: title,
                content: content,
                timestamp: (timestamp === 0) ? Math.floor(((new Date()).getTime()) / 1000) : timestamp
            }
    
            const bookCollection = this.db.transaction("books", "readwrite").objectStore("books");
            const bookAddRequest = bookCollection.add(data);
            bookAddRequest.onsuccess = (e) => {
                console.log("Added to IndexedDB");
                resolve();
            }

            bookAddRequest.onerror = (e) => {
                reject();
            }
        })
    }

    getNotebook = (slug) => {
        const db = this.db;

        return new Promise((resolve, reject) => {
            const bookCollection = db.transaction("books").objectStore("books");
            const d = bookCollection.get(slug);
            d.onsuccess = () => {
                resolve(d.result);
            }
        })

    }

    setAutoSave = async (slug, toEnableAutoSave = false) => {
        return new Promise((resolve, reject) => {
            const objectStore = this.db.transaction("books", "readwrite").objectStore("books");
            const request = objectStore.get(slug);
    
            request.onerror = function(event) {
                // Handle errors!
            };
    
            request.onsuccess = function(event) {
                // Get the old value that we want to update*
                const d = event.target.result;
                
                // update the value(s) in the object that you want to change
                d.autoSave = toEnableAutoSave;
    
                // Put this updated object back into the database.
                const requestUpdate = objectStore.put(d);
                requestUpdate.onerror = function(event) {
                    // Do something with the error
                };
    
                requestUpdate.onsuccess = function(event) {
                    // Success - the data is updated!
                    resolve(true);
                };
            };
        })
    }

    addContent = async (slug, content) => {
        const objectStore = this.db.transaction("books", "readwrite").objectStore("books");
        const request = objectStore.get(slug);

        request.onerror = function(event) {
            // Handle errors!
        };

        request.onsuccess = function(event) {
            // Get the old value that we want to update*
            const d = event.target.result;
            
            // update the value(s) in the object that you want to change
            d.content = content;
            d.timestamp = Math.floor((new Date()).getTime() / 1000);

            // Put this updated object back into the database.
            const requestUpdate = objectStore.put(d);
            requestUpdate.onerror = function(event) {
                // Do something with the error
            };

            requestUpdate.onsuccess = function(event) {
                // Success - the data is updated!
            };
        };
    }
}

export default (new IndexedDBService());